import ApplicationController from './application_controller'
import $ from 'jquery'

export default class extends ApplicationController
  @values = {subdirs: Object}
  @targets: ['table', 'path', 'file', 'progress', 'submit']

  # Confirm package load over 10 count
  confirm: (event) ->
    count = $(@tableTarget).find('.td.icon input[type="checkbox"]:checked').length
    count <= 10 or confirm("Are you sure you want to load #{count} packages?") or event.preventDefault()

  # Select files to upload
  select: (event) -> $(@fileTarget).click(); event.preventDefault()

  # Upload asset files or zipped packages
  load: (event) ->
    return unless $(@fileTarget).prop('files').length
    if $(@fileTarget).data('prompt')
      components = [$(@fileTarget).prop('files')...].map (file) => file.name.split('.')
      type = components.map((component) => '.' + component.slice(-1)[0]).uniq()
      subtype = components[0].slice(-2).join('.')
      $(@fileTarget).data('prompt')['default'] = ''
      if type.length is 1
        $(@fileTarget).data('prompt')['default'] =
          @subdirsValue[subtype] || @subdirsValue[type] || @subdirsValue['.asset']
      $(@fileTarget).attr 'data-prompt', JSON.stringify $(@fileTarget).data('prompt')
      return unless Rails.handlePrompt.call $(@fileTarget).get(0), event

    $(@pathTarget).val new URLSearchParams($(@fileTarget).attr 'data-params').get('asset_path') if @hasPathTarget

    result = await fetch $(@submitTarget).attr('formaction') || $(@element).attr('action'),
                         method: 'POST', headers: {'Accept': 'application/javascript'},
                         body: new FormData(@element), credentials: 'include'
    new Function(await result.text())()

    $(@fileTarget).prop 'value', ''
